import React from 'react';
import { Text } from '@react-pdf/renderer';
import compose from '../styles/compose';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Calendar2 } from 'react-bootstrap-icons';

function formatDateForPDF(value) {
  if (!value) return '';
  const [year, month, day] = value.split('-');
  if (!year || !month || !day) return value;
  const date = new Date(`${year}-${month}-${day}`);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
}

function parseDateString(dateStr) {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day));
}

function formatToInputDate(dateObj) {
  if (!(dateObj instanceof Date) || isNaN(dateObj)) return '';
  return dateObj.toISOString().split('T')[0];
}

const EditableInput = ({
  className,
  placeholder,
  value = '',
  onChange,
  pdfMode,
  type,
  readOnly,
  maxLength,
  pattern,
  onBlur,
  aria,
  title,
  required,
  calendar // if true, renders a date picker
}) => {
  if (pdfMode) {
    return (
      <Text style={[compose('span ' + (className || '')), { fontSize: 10 }]}>
        {calendar ? formatDateForPDF(value) : value}
      </Text>
    );
  }

  const inputClass = 'input dateinput' + (className || '');

  if (calendar) {
    return (
      <div className="datepicker-wrapper" style={{ position: 'relative' }}>
        <Calendar2
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: '#666'
          }}
        />
        <DatePicker
          selected={parseDateString(value)}
          onChange={(date) => {
            const formatted = formatToInputDate(date);
            onChange && onChange(formatted);
          }}
          placeholderText={placeholder || 'Select Date'}
          className={inputClass}
          dateFormat="MM/dd/yyyy"
          disabled={readOnly}
          required={required}
          title={title}
          aria-label={aria}
          onBlur={onBlur ? (e) => onBlur(e.target.value) : undefined}
        />

      </div>
    );
  }

  return (
    <input
      type={type || 'text'}
      pattern={pattern || ''}
      maxLength={maxLength > 0 ? maxLength : undefined}
      readOnly={readOnly}
      className={inputClass}
      value={value}
      required={required}
      placeholder={placeholder || ''}
      title={title}
      aria-label={aria}
      onBlur={onBlur ? (e) => onBlur(e.target.value) : undefined}
      onChange={onChange ? (e) => onChange(e.target.value) : undefined}
    />
  );
};

export default EditableInput;
